const initialState = {
  workOrderType: 'all',
  workOrderStatus: 'waitNwork',
  startDate: '',
  endDate: '',
  searchData: {},
  searchOption: '',
  searchText: '',
  pageNumber: 1,
  totalSize: 0,
  isPushedSearchButton: false,
}
const resetState = {
  workOrderType: 'all',
  workOrderStatus: 'waitNwork',
  startDate: '',
  endDate: '',
  searchData: {},
  searchOption: '',
  searchText: '',
  pageNumber: 1,
  totalSize: 0,
  isPushedSearchButton: false,
};

const productionOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SETPRODUCTIONORDERWORKORDERTYPE':
      return {
        ...state,
        workOrderType: action.payload,
      };
    case 'SETPRODUCTIONORDERWORKORDERSTATUS':
      return {
        ...state,
        workOrderStatus: action.payload,
      };
    case 'SETPRODUCTIONORDERSTARTDATE':
      return {
        ...state,
        startDate: action.payload,
      };
    case 'SETPRODUCTIONORDERENDDATE':
      return {
        ...state,
        endDate: action.payload,
      };
    case 'SETPRODUCTIONORDERSEARCHDATA':
      return {
        ...state,
        searchData: action.payload,
      };
    case 'SETPRODUCTIONORDERSEARCHOPTION':
      return {
        ...state,
        searchOption: action.payload,
      };
    case 'SETPRODUCTIONORDERSEARCHTEXT':
      return {
        ...state,
        searchText: action.payload,
      };
    case 'SETPRODUCTIONORDERPAGENUMBER':
      return {
        ...state,
        pageNumber: action.payload,
      };
    case 'SETPRODUCTIONORDERTOTALSIZE':
      return {
        ...state,
        totalSize: action.payload,
      };
    case 'SETPRODUCTIONORDERISPUSHEDSEARCHBUTTON':
      return {
        ...state,
        isPushedSearchButton: action.payload,
      };
    case 'SETPRODUCTIONORDERRESET':
      return {
        ...state,
        ...resetState,
      };
    default:
      return state;
  };
};

export default productionOrderReducer;